module.exports = __webpack_public_path__ + "static/media/staff-associated.70928327.svg";